/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Faq_Q2Inputs */

const es_marketplace_seo_galicia_faq_q2 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo llego a las Islas Cíes en barco?`)
};

const gl_marketplace_seo_galicia_faq_q2 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como chego ás Illas Cíes en barco?`)
};

const en_marketplace_seo_galicia_faq_q2 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I get to Cíes islands by boat?`)
};

/**
* | output |
* | --- |
* | "How do I get to Cíes islands by boat?" |
*
* @param {Marketplace_Seo_Galicia_Faq_Q2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_faq_q2 = /** @type {((inputs?: Marketplace_Seo_Galicia_Faq_Q2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Faq_Q2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_faq_q2(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_faq_q2(inputs)
	return es_marketplace_seo_galicia_faq_q2(inputs)
});